import axios from 'axios';
import { apiPath, config, configForFormData,configForDownloadBlob} from '../config/ApiConfig';


export function get(endPoint, inputParam, sucessCallback, errorCallback) {
    return axios.get(`${apiPath}${endPoint}${inputParam}`, config)
        	.then(response => response.data)
        	.then(sucessCallback)
            .catch(errorCallback);
 }

 export function getVippsAuthInfo(endPoint, sucessCallback, errorCallback) {
    return axios.get(`${endPoint}`)
        	.then(response => response.data)
        	.then(sucessCallback)
            .catch(errorCallback);
 }

 export function downloadDocument(downloadUrl, successCallback, errorCallback)
 {
   return axios.get(`${apiPath}${downloadUrl}`,configForDownloadBlob )
    .then(successCallback)
    .catch(errorCallback);
 }

 export function post(endPoint, inputParam, sucessCallback, errorCallback) {
    return axios.post(`${apiPath}${endPoint}`,{...inputParam}, config)
        	.then(response => response.data)
        	.then(sucessCallback)
            .catch(errorCallback);
 }

 export function postFormData(endPoint, inputParam, successCallback, errorCallback) {
    return axios.post(`${apiPath}${endPoint}`, inputParam, configForFormData)
        .then(response => response.data)
        .then(successCallback)
        .catch(errorCallback);
}
 